import { LayingType } from 'pages/common/components/LayingTypeField/const';
import { DIMENSIONS_DEFAULT_VALUES } from 'pages/common/consts/dimensions-default-values';
import { Inputs } from '../types';

export const getDefaultValues = ({
  hasDoors,
  hasThickness,
  dimensionState,
}: {
  hasDoors: boolean;
  hasThickness: boolean;
  dimensionState: Partial<Inputs>;
}) => ({
  ...(hasDoors && { doors: DIMENSIONS_DEFAULT_VALUES.DOORS_COUNT }),
  ...(hasThickness && { thickness: LayingType.horizontal }),
  ...{
    width: DIMENSIONS_DEFAULT_VALUES.WIDTH,
    length: DIMENSIONS_DEFAULT_VALUES.LENGTH,
    layerThickness: DIMENSIONS_DEFAULT_VALUES.LAYER_THICKNESS,
    area: DIMENSIONS_DEFAULT_VALUES.AREA,
    height: DIMENSIONS_DEFAULT_VALUES.HEIGHT,
  },
  ...dimensionState,
});
